import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const createRestaurant = createAsyncThunk(
  "restaurants/createRestaurant",
  async (newRestaurant) => {
    const response = await axios.post(
      `${BASE_URL}/api/restaurants`,
      newRestaurant
    );
    return response.data;
  }
);

const restaurantSlice = createSlice({
  name: "restaurants",
  initialState: {
    restaurant: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearRestaurant: (state) => {
      state.restaurant = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // create restaurant
      .addCase(createRestaurant.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createRestaurant.fulfilled, (state, action) => {
        state.restaurant = action.payload; // created restaurant
        state.isLoading = false;
      })
      .addCase(createRestaurant.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearRestaurant } = restaurantSlice.actions;

export default restaurantSlice.reducer;
